<template>
    <div>
        <div class="box"></div>
        <div class="box2">
            <div class="lef">
                <div>动画视频</div>
                <p v-for="item in menuList" :key="item.id">
                    <a :class="item.id==code? 'don':''" @click="menuClick(item.id)">· {{item.title}}</a>
                </p>
            </div>
            <div v-if="dataList" class="rit">
                <p class="tit">{{dataList.title}}</p>
                <div class="vid">
                    <iframe :src="dataList.url" width="100%" height="100%" frameborder="0" allowFullScreen></iframe>
                </div>
                <div class="but">
                    <span class="l" @click="upClick(dataList.id)">上一篇</span>
                    <span class="r" @click="nextClick(dataList.id)">下一篇</span>
                </div>
            </div>
            <div v-else class="prop">暂时没有内容~</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewsCeter",
        data(){
            return{
                code:sessionStorage.getItem('carCode3'),
                dataList:{},
                menuList:[
                    {id:1,title:'深圳地铁红树湾物业开发项目',url:'https://player.youku.com/embed/XMTQxMTQzMTE3Ng=='},
                    {id:2,title:'中建三局投标动画',url:'https://player.youku.com/embed/XMTM5NTIwMTk2MA='},
                    {id:3,title:'华润深圳湾国际投标动画',url:'https://player.youku.com/embed/XMTM4OTEwODU4MA=='},
                    {id:4,title:'安全生产警示片-高处坠落案例',url:'https://player.youku.com/embed/XMTM4OTEyODQ2NA=='},
                    {id:5,title:'潍坊白浪河大桥摩天轮施工动画演示',url:'https://player.youku.com/embed/XMTQ0MDg3MzQ3Ng=='},
                    {id:6,title:'中建ASTAK施工动画',url:'https://player.youku.com/embed/XMTM5NTE5MjQ1Ng==='},
                    {id:7,title:'水电站投标动画',url:'https://player.youku.com/embed/XMTM5NTE5MDA4NA=='},
                    {id:8,title:'中建钢构投标动画',url:'https://player.youku.com/embed/XMTM5NTE5NjU4MA=='},
                    {id:9,title:'平安大厦超高层施工动画',url:'https://player.youku.com/embed/XMTM5NTE3ODYwOA=='}
                ]
            }
        },
        methods:{
            menuClick(id){
                if(this.code!==id){
                    this.code=id;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode3',id);
                }
            },
            upClick(id){
                if(id!==1){
                    this.code=id-1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode3',id-1);
                }
            },
            nextClick(id){
                let count=this.menuList.length;
                if(id!==count){
                    this.code=id+1;
                    this.dataList=this.menuList[this.code-1];
                    sessionStorage.setItem('carCode3',id+1);
                }
            }
        },
        mounted(){
            this.dataList=this.menuList[this.code-1];
            document.documentElement.scrollTop=0;
        }
    }
</script>

<style lang="scss" scoped>
    .box{
        height: 2.9rem;
        width: 100%;
        background: url("../../assets/images/apply/al.jpg");
        background-size: 100% 100%;
    }
    .box2{
        width: 12rem;
        margin:.6rem auto 0;
        display: flex;
        .lef{
            width: 1.76rem;
            overflow: hidden;
            div{
                font-size: .2rem;
                position: relative;
                padding-left: .1rem;
                margin-bottom:.19rem;
            }
            div::before{
                position: absolute;
                content: "";
                left:0rem;
                top:.06rem;
                background: #E70F20;
                width: 2px;
                height: .16rem;
            }
            p{
                line-height: .34rem;
                font-size: .16rem;
                width: 1.76rem;
                color:#3F3F3F;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                cursor:pointer;
                a{
                    display: inline-block;
                    width: 100%;
                }
            }
            .don{
                color:#E70F20
            }
        }
        .rit{
            margin-left: .15rem;
            border-left: 1px solid #E5E5E5;
            padding-left:.85rem;
            width: 10.07rem;
            p.tit{
                width: 5.7rem;
                font-size: .26rem;
                text-align: center;
                margin: 0 auto;
                line-height: .41rem;
                letter-spacing: 1px;
            }
            div.vid{
                margin:.58rem auto 0;
                width: 7rem;
                height: 3.94rem;
            }
            div.but{
                text-align: center;
                margin-top:.56rem;
                span{
                    width: 69px;
                    height: 26px;
                    line-height: 29px;
                    display: inline-block;
                    font-size: 12px;
                    margin:0 .25rem;
                    cursor: pointer;
                }
                .l{
                    background: url("../../assets/images/pg.png");
                    background-size: 100% 100%;
                    padding-left:.07rem
                }
                .r{
                    background: url("../../assets/images/pg2.png");
                    background-size: 100% 100%;
                    padding-right:.07rem
                }
            }
        }
        .prop{
            width: 10rem;
            font-size: .26rem;
            color:#ddd;
            text-align: center;
            padding-top:1rem;
        }
    }
</style>
